
import { Alert, AlertDescription } from "@/components/ui/alert";

interface CourseLibraryStatusProps {
  isInactive: boolean;
  resourcesUsed: number;
  maxResources: number;
  canCreateMore: boolean;
}

export function CourseLibraryStatus({ 
  isInactive, 
  resourcesUsed, 
  maxResources, 
  canCreateMore 
}: CourseLibraryStatusProps) {
  if (isInactive) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          Your account is currently inactive. Please update your billing information to continue.
        </AlertDescription>
      </Alert>
    );
  }

  if (!canCreateMore) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          You've reached your resource limit ({resourcesUsed}/{maxResources}).
          Please upgrade your plan to create more resources.
        </AlertDescription>
      </Alert>
    );
  }

  return null;
}
